module.exports = __webpack_public_path__ + "static/media/hot34.b2375301.jpg";